export const localStorageRefreshTokenKey = 'apiRefreshToken'
export const localStorageTokenKey = 'apiToken'
export const localStorageIsAuthenticatedKey = 'authenticated'
export const localStorageUserIsIdleKey = 'userIsIdle'
